import React, { useState, useEffect } from 'react';
import { Row, Col, Typography, Card, List, Spin, Alert } from 'antd';
import ReactMarkdown from 'react-markdown';
import { createApiGateway } from '../../../apiGateway';

const { Text } = Typography;

export default function Documentation() {
  const [documentationList, setDocumentationList] = useState([]);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const apiGateway = createApiGateway();

  const fetchDocumentationList = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiGateway.documentation.getAll();
      setDocumentationList(response || []);
    } catch (err) {
      setError('Failed to load documentation list');
      console.error('Error fetching documentation:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDocumentationList();
  }, []);

  const fetchDocumentationById = async (id) => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiGateway.documentation.getById(id);
      setSelectedDoc(response);
    } catch (err) {
      setError('Failed to load documentation');
      console.error('Error fetching documentation by ID:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ width: '100%', padding: '20px' }}>
      {error && (
        <Row>
          <Col xs={24}>
            <Alert title={error} type="error" showIcon />
          </Col>
        </Row>
      )}

      <Row gutter={[16, 16]}>
        <Col xs={24} md={8}>
          <Card title="Documentation Pages" style={{ marginBottom: 20 }}>
            <Spin spinning={loading}>
              <List
                dataSource={documentationList}
                renderItem={(item) => (
                  <List.Item>
                    <List.Item.Meta
                      title={<a onClick={() => fetchDocumentationById(item.id)}>{item.title}</a>}
                      description={item.description}
                    />
                  </List.Item>
                )}
              />
            </Spin>
          </Card>
        </Col>

        <Col xs={24} md={16}>
          <Card title={selectedDoc?.title || 'Select a documentation page'}>
            <Spin spinning={loading}>
              {selectedDoc ? (
                <div>
                  <div
                    style={{
                      minHeight: '400px',
                      lineHeight: '1.6',
                      fontSize: '14px',
                    }}
                  >
                    <ReactMarkdown>{selectedDoc.content}</ReactMarkdown>
                  </div>
                  {selectedDoc.lastUpdated && (
                    <Text type="secondary" style={{ marginTop: 20, display: 'block' }}>
                      Last updated: {new Date(selectedDoc.lastUpdated).toLocaleDateString()}
                    </Text>
                  )}
                </div>
              ) : (
                <Text type="secondary">Please select a documentation page from the list on the left.</Text>
              )}
            </Spin>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
